"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeLanguage = exports.init = void 0;
var package_domain;
var head;
var init = function (env, options) {
    // 1. Read the configuration file json
    var xMLHttpRequest = new XMLHttpRequest();
    var domain = window.location.host;
    options = options || { 'configoverwrite': 'N' };
    if (!('configoverwrite' in options)) {
        options.configoverwrite = 'N';
    }
    var _url = getURL(window.location.href, options.configoverwrite);
    xMLHttpRequest.open('GET', _url, false); // `false` makes the request synchronous
    xMLHttpRequest.send(null);
    var config = '';
    if (xMLHttpRequest.status === 200) {
        config = JSON.parse(xMLHttpRequest.responseText);
    }
    else {
        throw new Error('File config not found');
    }
    var cookieConfig = config[domain];
    if (typeof (cookieConfig) === 'undefined') {
        throw new Error('Wrong cookies configuration for this site');
    }
    head = document.getElementsByTagName('head')[0];
    var teconsent = document.getElementById('teconsent');
    var styleLink = document.createElement('link');
    var css = document.createElement('style');
    var manage_cookies = document.createElement('a');
    var strLanguage = 'en';
    if ('undefined' !== typeof (options.locale) && '' !== options.locale) {
        strLanguage = options.locale.toString().substring(0, 2);
    }
    else if ('undefined' !== typeof (options.language) && '' !== options.language) {
        strLanguage = options.language;
    }
    var style_link = 'https://fonts.googleapis.com/css?family=Noto+Sans';
    manage_cookies.setAttribute('href', '#');
    manage_cookies.setAttribute('id', 'ccm_manage_cookies_msat');
    manage_cookies.innerText = getLangManageCookies(strLanguage);
    manage_cookies.setAttribute('onclick', "Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')");
    teconsent === null || teconsent === void 0 ? void 0 : teconsent.appendChild(manage_cookies);
    try {
        package_domain = cookieConfig.package;
    }
    catch (error) {
        package_domain = 'ccce59a3-d247-48bb-9d6a-fbeb0ea06797';
    }
    addScript(strLanguage);
    styleLink.href = style_link;
    styleLink.setAttribute('rel', 'stylesheet');
    styleLink.setAttribute('type', 'text/css');
    head.appendChild(styleLink);
    var styles = '.osano-cm-widget { display:none }';
    css.appendChild(document.createTextNode(styles));
    head.appendChild(css);
};
exports.init = init;
function addScript(strLanguage) {
    var script = document.getElementById('ccm_script_cookies_msat');
    if (script != undefined) {
        script.remove();
    }
    var script_url = '//cmp.osano.com/16CFuWSuPfE35eNP/' + package_domain + '/osano.js?language=' + strLanguage;
    var scriptNew = document.createElement('script');
    scriptNew.setAttribute('id', 'ccm_script_cookies_msat');
    scriptNew.src = script_url;
    scriptNew.setAttribute('async', 'async');
    head.appendChild(scriptNew);
}
function getURL(host, configoverwrite) {
    var url_json = 'msat-cookies-handler-config.json';
    var url_clean = '';
    if (configoverwrite == 'N') {
        document.querySelectorAll('script[src]').forEach(function (sc) {
            var index = sc.src.indexOf('/msat-cookies-handler.min.js');
            if (index > 0) {
                url_clean = sc.src.substring(0, index + 1) + url_json;
            }
        });
    }
    else if (configoverwrite.startsWith('http')) {
        url_clean = configoverwrite;
    }
    else if (configoverwrite.startsWith('./')) {
        url_clean = window.location.origin + configoverwrite.substring(1);
    }
    else {
        url_clean = host + configoverwrite;
    }
    return url_clean;
}
function getLangManageCookies(code) {
    var transalation = {};
    transalation.en = 'Manage Cookies';
    transalation.fr = 'Gérer les cookies';
    transalation.fi = 'Hallitse evästeitä';
    transalation.de = 'Cookies verwalten';
    transalation.es = 'Manejar las Cookies';
    transalation.it = 'Gestisci i cookie';
    transalation.pl = 'Zarządzaj plikami cookie';
    transalation.de = 'Cookies verwalten';
    transalation.nl = 'Cookies beheren';
    transalation.hu = 'Sütik kezelése';
    transalation.ro = 'Gestionare module cookie';
    transalation.pt = 'Gerir cookies';
    transalation.sk = 'Spravovať súbory cookie';
    transalation.ru = 'Управление файлами cookie';
    transalation.tr = 'Çerezleri Yönet';
    transalation.kk = 'Cookie файлдарын басқару';
    transalation.cs = 'Spravovat soubory cookie';
    transalation.da = 'Administrer cookier';
    transalation.no = 'Administrere informasjonskapsler';
    transalation.sv = 'Hantera cookies';
    transalation.el = 'Διαχείριση Cookies';
    transalation.ja = 'クッキー管理';
    transalation.zh = '管理 Cookie';
    transalation.ko = '쿠키 관리';
    transalation.ar = 'إدارة ملفات تعريف الارتباط ';
    var manageTranlations = transalation[code];
    if (manageTranlations == undefined || manageTranlations == "" || manageTranlations == null)
        manageTranlations = transalation['en'];
    return manageTranlations;
}
var changeLanguage = function (language) {
    var manage_cookies = document.getElementById('ccm_manage_cookies_msat');
    if (manage_cookies != undefined) {
        manage_cookies.innerText = getLangManageCookies(language);
    }
    addScript(language);
};
exports.changeLanguage = changeLanguage;
